import { RECEIVE_USER_IDENTITY, IDENTITY_SDK_FAILURE } from "../constants";
import { receiveUserIdentity, identitySdkFailure } from "./payloadCreators";

export default {
  [RECEIVE_USER_IDENTITY]: receiveUserIdentity,
  [IDENTITY_SDK_FAILURE]: identitySdkFailure
};
